import { faArrowsRotate, faBoxOpen, faTruckFast, IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ACCENT } from '~/components/ui'

const Step = ({
    n,
    icon,
    title,
    children,
}: {
    n: string
    icon: IconDefinition
    title: string
    children: string
}) => (
    <div className='flex items-center gap-4 border border-white/10 bg-white/[0.03] px-4 py-3.5'>
        <span className='w-6 shrink-0 text-sm font-black tabular-nums text-white/30'>{n}</span>
        <span className='grid h-10 w-10 shrink-0 place-items-center border border-white/15 bg-black/60 text-[#03CEFF]'>
            <FontAwesomeIcon icon={icon} />
        </span>
        <div className='flex flex-col'>
            <span className='text-sm font-black uppercase tracking-[0.12em]'>{title}</span>
            <span className='text-2xs font-semibold uppercase leading-relaxed tracking-[0.06em] text-white/45'>
                {children}
            </span>
        </div>
    </div>
)

/**
 * "How it works": the packs flow in three steps, in the house chrome. The
 * "Got it" button submits a `method="dialog"` form, which closes the native
 * <dialog> without the Dialog component needing to expose a close handler.
 */
export const HowItWorksModal = () => (
    <div className='flex flex-col gap-5'>
        <h2 className='text-lg font-black uppercase tracking-[0.14em]'>How it works</h2>

        <div className='flex flex-col gap-2.5'>
            <Step n='01' icon={faBoxOpen} title='Spin a pack'>
                Pay the pack price for a random BR1 weapon — the reels spin and reveal what you pulled.
            </Step>
            <Step n='02' icon={faArrowsRotate} title='Keep it or spin again'>
                Happy with the pull? Keep it. Not sure? Give it up and spin again for half price — as many times as you like. The weapon you give up goes back in the pool.
            </Step>
            <Step n='03' icon={faTruckFast} title='Collect &amp; deliver'>
                Collect to claim the weapon. It ships straight to your connected Solana wallet.
            </Step>
        </div>

        <p className='text-2xs font-bold uppercase leading-relaxed tracking-[0.08em] text-white/40'>
            Every weapon shown in &quot;What&apos;s inside&quot; is genuinely drawable — the reels can only
            ever land on a weapon the pack actually holds.
        </p>

        <form method='dialog'>
            <button
                style={{ background: ACCENT }}
                className='w-full px-6 py-3.5 text-sm font-black uppercase tracking-[0.2em] transition-[filter] hover:brightness-110'
            >
                Got it, let&apos;s spin
            </button>
        </form>
    </div>
)
